var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Admin',[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[(!_vm.selectedCompany.isDemo)?_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}})],1):_c('div',{staticClass:"align-center justify-center",staticStyle:{"height":"200px","display":"flex"}},[_vm._v(" No Permission ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }